import { object, string } from "yup";

export const passwordResetValidateSchema = object().shape({
  password: string().max(255).required("Password is required"),
  passwordConfirm: string().max(255).required("Password is required")
});
